export const INVOICES_COLLECTION = 'invoices';
export const BILLING_COUNTERS_COLLECTION = 'billingCounters';
